import jQuery from 'jquery'

const unparsableCurrencyValue = (value) =>
  value === undefined || value === '' || value === null

const formattedCurrency = (value, symbol, decimalPlaces, groupDigits) => {
  if (unparsableCurrencyValue(value)) return ''

  const negativeFormat = '-%s%n'

  const val = jQuery(`<span>${value}</span>`)
    .formatCurrency({
      symbol,
      colorize: false,
      roundToDecimalPlace: decimalPlaces,
      groupDigits,
      negativeFormat
    })
    .text()

  if (val === 'null') return null
  return val
}

const normalizeCurrencyValue = (value) =>
  parseFloat(value).toFixed(8).replace(/0{0,6}$/, '')

export const formatCurrency = (value, currencySymbol) =>
  formattedCurrency(
    value,
    currencySymbol || window.ppd.currencySymbol || '$',
    window.ppd.currencyDecimalPlaces,
    true
  )

export const formatCurrencyCustomField = (value, currencySymbol) => {
  let precision
  if (!isNaN(parseFloat(value))) {
    value = normalizeCurrencyValue(value)
    const decimals = value.split('.')[1]
    precision = decimals ? decimals.length : window.ppd.currencyDecimalPlaces
  } else {
    precision = window.ppd.currencyDecimalPlaces
  }
  return formattedCurrency(
    value,
    currencySymbol || window.ppd.currencySymbol,
    precision,
    true
  )
}
